/**
 * @generated SignedSource<<7095cdfe905f46e4b26de75bdc9bac46>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type listItem_AtlassianConversationAssistantAgent_AgentListItem$data = {
  readonly authoringTeam: {
    readonly displayName: string | null;
    readonly id: string;
    readonly profileUrl: string | null;
    readonly smallAvatarImageUrl: string | null;
  } | null;
  readonly conversationStarters: ReadonlyArray<string> | null;
  readonly creator: {
    readonly id: string;
  } | null;
  readonly creatorType: string | null;
  readonly deactivated: boolean | null;
  readonly description: string | null;
  readonly externalConfigReference: string | null;
  readonly icon: string | null;
  readonly id: string;
  readonly identityAccountId: string | null;
  readonly isFavourite: boolean | null;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"agentVerified_AtlaskitRovoAgentComponents">;
  readonly " $fragmentType": "listItem_AtlassianConversationAssistantAgent_AgentListItem";
};
export type listItem_AtlassianConversationAssistantAgent_AgentListItem$key = {
  readonly " $data"?: listItem_AtlassianConversationAssistantAgent_AgentListItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"listItem_AtlassianConversationAssistantAgent_AgentListItem">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "listItem_AtlassianConversationAssistantAgent_AgentListItem",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "deactivated"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ScalarField",
      "name": "creatorType"
    },
    {
      "kind": "ScalarField",
      "name": "conversationStarters"
    },
    {
      "kind": "ScalarField",
      "name": "identityAccountId"
    },
    {
      "kind": "ScalarField",
      "name": "externalConfigReference"
    },
    {
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "icon"
    },
    {
      "concreteType": "TeamV2",
      "kind": "LinkedField",
      "name": "authoringTeam",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "profileUrl"
        },
        {
          "kind": "ScalarField",
          "name": "displayName"
        },
        {
          "kind": "ScalarField",
          "name": "smallAvatarImageUrl"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "agentVerified_AtlaskitRovoAgentComponents"
    }
  ],
  "type": "AgentStudioAssistant"
};
})();

(node as any).hash = "ed993eee40a9275ed2a25ccb1513cc8b";

export default node;
